import * as React from "react";
import Image from "./Image";
import { midFunnelAdsNoResults } from "../lib/Avo";
import useAppSelector from "../hooks/useAppSelector";
import { useDidMount } from "rooks";
export default function NoAdsFound() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    useDidMount(function () {
        midFunnelAdsNoResults(commonAnalyticsProperties);
    });
    return (React.createElement("div", { className: "inherit flex grow flex-row items-center justify-center overflow-auto text-center font-proxima" },
        React.createElement("div", { className: "flex w-full flex-col items-center bg-white" },
            React.createElement(Image, { src: "/assets/icons/magnifying-glass.svg", alt: "Magnifying glass", className: "mb-2" }),
            React.createElement("h4", { className: "mx-6 mb-0.5 font-bold text-black-100" }, "Sorry, we couldn't find any offers"),
            React.createElement("p", { className: "mx-6 text-sm text-black-300" }, "We searched our network of insurers and couldn\u2019t find you any offers today. We will continue to monitor our network and reach out when we find a better deal."))));
}
